const useSkeleton = (root) => {
  const skeleton = {
    layout: {
      values: "",
      content: {
        values: "flex flex-column m-0 p-0 w-screen",
        header: {
          values: "flex justify-content-end align-items-center w-full pt-4 ",
          icon: {
            values: "ml-4 mr-15 text-4xl",
          },
          info: {
            values: "flex flex-column align-content-start pl-4",
            route: { values: "pl-1 text-600" },
            title: { values: "pl-1 text-4xl" },
          },
          actions: {
            values:
              "flex flex-grow-1 justify-content-end align-items-center pr-5 ",
          },
        },
      },
    },
    commons: {
      dataTableContainer: { values: "flex w-full p-4" },
    },
    abm: {
      values: "flex justify-content-center w-full",
      form: {
        values: "flex flex-column w-10",
        field: {
          values: "flex align-items-center w-full",
          label: { values: "flex pt-3 pr-4 w-4 h-2 justify-content-end" },
          value: {
            values: "flex flex-column w-7 justify-content-start",
            error: { values: "flex h-1rem justify-content-start" },
            control: {
              values: "flex flex-column justify-content-start",
            },
          },
        },
      },
    },
    withholdings: {
      values: "flex mb-4",
      header: {
        values: "flex  ml-5 mr-5",
        field: {
          values: "flex w-full h-3rem align-items-center",
          label: { values: "flex pr-2 align-items-center w-8rem" },
          control: {
            values: "flex w-9rem",
          },
        },
        summary: {
          values:
            "flex flex-column w-4 align-items-center justify-content-start border-1 border-300 mr-4 ",
          title: {
            values:
              "flex flex-column h-3rem w-full border-bottom-1 border-300 justify-content-center text-center mb-4 surface-ground",
          },
          rows: {
            values: "flex flex-column flex-grow-1 justify-content-center",
            row: { values: "flex flex-column h-3rem " },
          },
        },
        actions: {
          values: "flex flex-column w-8 row-gap-4",
          action: {
            values: "flex flex-column w-12 border-1 border-300",
            title: {
              values:
                "flex flex-column h-3rem w-full border-bottom-1 border-300 justify-content-center text-center surface-ground",
            },
            rows: {
              values: "flex w-full flex-row justify-content-center ",
              row: {
                values: "flex align-items-end",
                column: {
                  values: "flex flex-column align-items-center p-4",
                },
              },
            },
          },
        },
        button: {
          values: "p-button-secondary w-17rem",
        },
      },
    },
  };

  const getObject = (jsonItem, baseSkeleton) => {
    let result = baseSkeleton;

    const fields = jsonItem.toString().split(".");

    for (let i = 0; i < fields.length; i++) {
      result = result[fields[i]];
    }

    return result;
  };

  // Usar getObject para inicializar currentSkeleton
  let currentSkeleton = root ? getObject(root, skeleton) : skeleton;

  const get = (jsonItem) => {
    let result = currentSkeleton;

    if (jsonItem) {
      result = getObject(jsonItem, currentSkeleton);
    }
    result = result?.values ? result.values.replaceAll(",", " ") : "";

    return result;
  };

  return {
    get,
  };
};

export default useSkeleton;
